import type { FinancialSpecsData } from './HSPFinancialSpecs.types';

export const mockFinancialSpecsData: FinancialSpecsData = {
  basePrice: 172612,
  standardPackets: [
    {
      code: '4808',
      name: 'Pakiet M Sport',
      equipments: [
        {
          code: 'MSP001',
          name: 'Sportowe fotele',
          category: 'Interior',
          equipmentType: 'Standard',
          catalogPrice: 5000,
          currentMarketPrice: 4500,
        },
        {
          code: 'MSP002',
          name: 'Sportowa kierownica',
          category: 'Interior',
          equipmentType: 'Standard',
          catalogPrice: 2000,
          currentMarketPrice: 1800,
        },
      ],
      catalogPrice: 12345,
      currentMarketPrice: 11000,
      equipmentPacketType: 'Standard',
    },
  ],
  standardEquipments: [
    {
      code: 'STD001',
      name: 'Klimatyzacja automatyczna',
      category: 'Comfort',
      equipmentType: 'Standard',
      catalogPrice: 3115,
      currentMarketPrice: 2800,
    },
  ],
  optionalPackets: [],
  optionalEquipments: [
    {
      code: 'B20',
      name: 'Alarm bezpieczeństwa',
      category: 'Safety',
      catalogPrice: 1419,
      equipmentType: 'Optional',
      currentMarketPrice: 42.57,
    },
    {
      code: 'K11',
      name: 'Klimatyzacja automatyczna',
      category: 'Comfort',
      catalogPrice: 957,
      equipmentType: 'Optional',
      currentMarketPrice: 95.77,
    },
    {
      code: 'K4Q',
      name: 'Koło zapasowe pełnowymiarowe',
      category: 'Functionality',
      catalogPrice: 1089.01,
      equipmentType: 'Optional',
      currentMarketPrice: 32.67,
    },
    {
      code: 'L11',
      name: 'Lakier perłowy',
      category: 'Exterior appearance',
      catalogPrice: 2211,
      equipmentType: 'Optional',
      currentMarketPrice: 66.33,
    },
    {
      code: 'B77',
      name: 'Reflektory Bi-xenon',
      category: 'Exterior appearance',
      catalogPrice: 5082,
      equipmentType: 'Optional',
      currentMarketPrice: 508.53,
    },
    {
      code: 'B38',
      name: 'System parkowania dźwiękowy',
      category: 'Functionality',
      catalogPrice: 2013.01,
      equipmentType: 'Optional',
      currentMarketPrice: 201.44,
    },
    {
      code: 'K1B',
      name: 'Szyby przyciemniane',
      category: 'Exterior appearance',
      catalogPrice: 1337,
      equipmentType: 'Optional',
      currentMarketPrice: 133.79,
    },
    {
      code: 'J14',
      name: 'Tarcze kół ze stopow lekkich 17',
      category: 'Exterior appearance',
      catalogPrice: 2211,
      equipmentType: 'Optional',
      currentMarketPrice: 66.33,
    },
  ],
  optionalPackagesPrice: 0,
  optionalEquipmentPrice: 0,
  totalAdditionalEquipmentValue: 15460,
  totalStandardEquipmentValue: 15460,
  equipmentPercentage: 9.2,
  hasOptionalEquipment: false,
  hasPackages: true,
};

export const mockFinancialSpecsDataWithOptional: FinancialSpecsData = {
  basePrice: 185000,
  standardPackets: [
    {
      code: '5001',
      name: 'Pakiet Premium',
      equipments: [
        {
          code: 'PREM001',
          name: 'Skórzana tapicerka',
          category: 'Interior',
          equipmentType: 'Standard',
          catalogPrice: 6000,
          currentMarketPrice: 5500,
        },
      ],
      catalogPrice: 8500,
      currentMarketPrice: 7800,
      equipmentPacketType: 'Standard',
    },
  ],
  standardEquipments: [],
  optionalPackets: [
    {
      code: '5002',
      name: 'Pakiet Sport',
      equipments: [
        {
          code: 'SPT001',
          name: 'Zawieszenie sportowe',
          category: 'Performance',
          equipmentType: 'Optional',
          catalogPrice: 4000,
          currentMarketPrice: 3600,
        },
      ],
      catalogPrice: 6200,
      currentMarketPrice: 5600,
      equipmentPacketType: 'Optional',
    },
  ],
  optionalEquipments: [
    {
      code: 'OPT001',
      name: 'Panoramiczny dach',
      category: 'Exterior',
      equipmentType: 'Optional',
      catalogPrice: 4300,
      currentMarketPrice: 3900,
    },
  ],
  optionalPackagesPrice: 6200,
  optionalEquipmentPrice: 4300,
  totalAdditionalEquipmentValue: 19000,
  totalStandardEquipmentValue: 8500,
  equipmentPercentage: 10.3,
  hasOptionalEquipment: true,
  hasPackages: true,
};

export const mockFinancialSpecsDataMinimal: FinancialSpecsData = {
  basePrice: 95000,
  standardPackets: [],
  standardEquipments: [],
  optionalPackets: [],
  optionalEquipments: [],
  optionalPackagesPrice: 0,
  optionalEquipmentPrice: 0,
  totalAdditionalEquipmentValue: 0,
  totalStandardEquipmentValue: 0,
  equipmentPercentage: 0,
  hasOptionalEquipment: false,
  hasPackages: false,
};
